/* deployed: 2026-05-04T13:27:17Z BTA fix F-bta-missing-datetime */
/** Shopify CDN: Minification failed

Line 193:10 Unexpected "in"

**/
/* ============================================
   OmyBoat — omyboat.js
   Shared JS: navbar, mobile menu, hero, flatpickr
   ============================================ */

/* ---- BTA : NE PAS RENOMMER les properties cart/add ----
   Historique : un hook précédent renommait Start→Début / Finish→Fin /
   Units→_Units côté JS pour afficher des libellés FR au panier.
   ⚠️ Cela cassait silencieusement BTA : son worker post-checkout cherche
   les clés exactes "Start" / "Finish" / "Units" pour créer la booking.
   Quand elles sont absentes, BTA envoie l'email "Missing Date/Time" et
   ne marque pas le créneau comme bookéé → risque de double-booking.
   Voir tests/run-reports/F-bta-missing-datetime-FIX-RAPPORT.md (2026-05-04).
   Ne JAMAIS réintroduire ce hook. Si on veut un libellé FR au panier,
   passer par les Service Labels côté admin BTA (n'affecte que l'UI,
   pas les clés properties techniques) ou par un override CSS/Liquid
   du template panier qui mappe l'affichage sans toucher aux clés.
---------------------------------------------------------------- */

document.addEventListener('DOMContentLoaded', function () {

  /* ---- NAVBAR SCROLL ---- */
  var nav = document.querySelector('.omyboat-nav');
  if (nav) {
    window.addEventListener('scroll', function () {
      nav.classList.toggle('scrolled', window.scrollY > 50);
    }, { passive: true });
  }

  /* ---- MOBILE MENU TOGGLE ---- */
  var hamburger = document.querySelector('.nav-hamburger');
  var mobileMenu = document.querySelector('.nav-mobile');
  if (hamburger && mobileMenu) {
    hamburger.setAttribute('aria-expanded', 'false');
    hamburger.addEventListener('click', function () {
      hamburger.classList.toggle('open');
      mobileMenu.classList.toggle('open');
      hamburger.setAttribute('aria-expanded', String(hamburger.classList.contains('open')));
    });
    mobileMenu.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        hamburger.classList.remove('open');
        mobileMenu.classList.remove('open');
        hamburger.setAttribute('aria-expanded', 'false');
      });
    });
    document.addEventListener('click', function (e) {
      if (!nav.contains(e.target) && !mobileMenu.contains(e.target)) {
        hamburger.classList.remove('open');
        mobileMenu.classList.remove('open');
        hamburger.setAttribute('aria-expanded', 'false');
      }
    });
  }

  /* ---- ACTIVE LINK DETECTION ---- */
  var currentPath = window.location.pathname;
  document.querySelectorAll('.omyboat-nav .nav-links a').forEach(function (link) {
    if (link.getAttribute('href') === currentPath) {
      link.classList.add('active');
    }
  });

  /* ---- FLATPICKR DATE PICKERS ---- */
  if (typeof flatpickr !== 'undefined') {
    var pickerFrom = flatpickr('#hero-date-from', {
      locale: 'fr',
      dateFormat: 'Y-m-d',
      altInput: true,
      altFormat: 'd/m/Y',
      minDate: 'today',
      disableMobile: false,
      onChange: function (selectedDates) {
        if (selectedDates.length > 0) {
          pickerTo.set('minDate', selectedDates[0]);
          if (!pickerTo.selectedDates.length) {
            pickerTo.open();
          }
        }
      }
    });
    var pickerTo = flatpickr('#hero-date-to', {
      locale: 'fr',
      dateFormat: 'Y-m-d',
      altInput: true,
      altFormat: 'd/m/Y',
      minDate: 'today',
      disableMobile: false
    });
  }

  /* ---- SELECT COLOR STATE ---- */
  document.querySelectorAll('.sf select').forEach(function (sel) {
    var update = function () {
      sel.classList.toggle('has-value', sel.value !== '');
    };
    update();
    sel.addEventListener('change', update);
  });

  /* ---- HERO PORT AUTOCOMPLETE ---- */
  (function () {
    var dataEl = document.getElementById('hero-villes-json');
    if (!dataEl) return;
    var VILLES;
    try { VILLES = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var input  = document.getElementById('heroPortInput');
    var hidden = document.getElementById('heroPortValue');
    var drop   = document.getElementById('heroPortDropdown');
    if (!input || !hidden || !drop) return;

    /* normalise: minuscules, sans accents */
    function norm(s) {
      return (s || '').toLowerCase()
        .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-z0-9 ]/g, '');
    }

    function search(q) {
      if (!q || !q.trim()) return VILLES;
      var nq = norm(q);
      return VILLES.filter(function (v) {
        return norm(v.nom).indexOf(nq) !== -1 || v.slug.indexOf(nq) !== -1;
      });
    }

    function positionDrop() {
      var r = input.getBoundingClientRect();
      drop.style.top  = (r.bottom + 6) + 'px';
      drop.style.left = r.left + 'px';
      drop.style.minWidth = Math.max(r.width, 200) + 'px';
    }

    function renderDrop(results) {
      drop.innerHTML = '';
      if (!results.length) { drop.classList.remove('open'); return; }
      positionDrop();
      results.forEach(function (v) {
        var item = document.createElement('div');
        item.className = 'hpd-item';
        item.innerHTML = '<span class="hpd-emoji">' + v.emoji + '</span>' +
                         '<span class="hpd-nom">'  + v.nom   + '</span>';
        item.addEventListener('mousedown', function (e) {
          e.preventDefault(); /* evite blur avant click */
          input.value  = v.nom;
          hidden.value = v.slug;
          drop.classList.remove('open');
        });
        drop.appendChild(item);
      });
      drop.classList.add('open');
    }

    input.addEventListener('input', function () {
      renderDrop(search(this.value));
    });

    input.addEventListener('focus', function () {
      positionDrop();
      renderDrop(search(this.value));
    });

    input.addEventListener('blur', function () {
      setTimeout(function () { drop.classList.remove('open'); }, 150);
    });

    window.addEventListener('resize', positionDrop);
  })();

  /* ---- BTA : traduction EN du widget ---- */
  btaApplyEnTranslations();

}); /* end DOMContentLoaded */

/* ============================================
   BTA widget — EN translation override
   BTA uses a single language set; on EN pages
   we override visible French strings in the
   same-origin iframe BTA renders into.
   ============================================ */
function btaApplyEnTranslations() {
  if (!/\/en\//.test(window.location.pathname)) return;

  var TRANSLATIONS = {
    'Choisissez vos dates':   'Choose your dates',
    'Date de départ':         'Start date',
    'Date de retour':         'End date',
    'Sélectionnez vos dates': 'Select your dates',
    'Prix:':                  'Price:'
  };

  function applyToDoc(doc) {
    if (!doc || !doc.body) return;
    var walker = doc.createTreeWalker(doc.body, NodeFilter.SHOW_TEXT, null, false);
    var node;
    while ((node = walker.nextNode())) {
      var t = node.textContent.trim();
      if (TRANSLATIONS[t]) { node.textContent = TRANSLATIONS[t]; }
    }
  }

  function findBtaIframe() {
    return Array.from(document.querySelectorAll('iframe')).find(function (f) {
      var s = f.getAttribute('src');
      return !s || s === 'about:blank';
    });
  }

  function tryApply() {
    var frame = findBtaIframe();
    if (!frame) { setTimeout(tryApply, 300); return; }
    var doc = frame.contentDocument || (frame.contentWindow && frame.contentWindow.document);
    if (!doc || !doc.body || !doc.body.textContent.trim()) { setTimeout(tryApply, 300); return; }
    applyToDoc(doc);
    /* Re-apply on DOM mutations — BTA updates text after date selection */
    new MutationObserver(function () { applyToDoc(doc); })
      .observe(doc.body, { childList: true, subtree: true, characterData: true });
  }

  tryApply();
}


/* ============================================================
   Crisp -- auto-open sur les fiches bateaux
   - 1 seule fois par session (sessionStorage)
   - puis cooldown 7 jours (localStorage)
   ============================================================ */
(function () {
  if (!window.location.pathname.startsWith('/products/')) return;

  // Sentry THEME-STOREFRONT-J : sessionStorage/localStorage peuvent lever une
  // SecurityError (webview restreinte, storage bloque) -- tout l'IIFE reste
  // best-effort pour ne pas planter le reste du script si l'acces est refuse.
  try {
    var SESSION_KEY = 'omyboat_crisp_greeted';
    var LS_KEY      = 'omyboat_crisp_greeted_at';
    var COOLDOWN_MS = 7 * 24 * 60 * 60 * 1000; // 7 jours

    // Deja affiche dans cet onglet/session ?
    if (sessionStorage.getItem(SESSION_KEY)) return;

    // Deja affiche il y a moins de 7 jours ?
    var lastShown = parseInt(localStorage.getItem(LS_KEY) || '0', 10);
    if (Date.now() - lastShown < COOLDOWN_MS) return;

    var fired = false;
    function crispAutoOpen() {
      if (fired) return;
      if (!window.$crisp) return;
      fired = true;
      try {
        sessionStorage.setItem(SESSION_KEY, '1');
        localStorage.setItem(LS_KEY, String(Date.now()));
      } catch (e) {}
      $crisp.push(['do', 'chat:open']);
      $crisp.push(['do', 'message:show', ['text',
      "Bonjour 👋 Si vous avez des questions sur ce bateau, n\'hésitez pas à me demander !"
      ]]);
    }

    var check = setInterval(function () {
      if (window.$crisp) {
        clearInterval(check);
        setTimeout(crispAutoOpen, 5000);
      }
    }, 200);
  } catch (e) {}
})();
